/// <reference path="../../../../Frontend.Core/dist/definitions/NCB.d.ts" />
import * as React from "react";
import appstate from "../../appstate";
import "./guestSelector.scss";
import { NumericInput, NumericInputType } from "../shared/numericInput";

export interface IGuestSelectorProps {
    guestCount: CC.Library.Models.Calendar.NcbCalendarRoom[],
    changeCallback: (rooms: CC.Library.Models.Calendar.NcbCalendarRoom[]) => void,
    limitGuestSelection: boolean,
    forceHide: boolean,
    onSubmit: () => void,
    isSubmitEnbled: boolean,
    forceSimpleGuestSelector: boolean,
    isGuestControlToggled?: boolean
}

export interface IGuestSelectorState {
    guestCount: CC.Library.Models.Calendar.NcbCalendarRoom[],
    showMaxOccupancyMessage: boolean,
    isGuestControlToggled: boolean,
    showMaxRoomMessage: boolean,
    showExpandedOptions: boolean,
    useSimpleGuestSelector: boolean
}

export class GuestSelector extends React.Component<IGuestSelectorProps, IGuestSelectorState> {

    maxAdults: number;
    maxChildren: number;

    constructor(props: IGuestSelectorProps) {
        super(props);

        this.props = props;

        this.handleChange = this.handleChange.bind(this);
        this.addAdult = this.addAdult.bind(this);
        this.removeAdult = this.removeAdult.bind(this);
        this.addChild = this.addChild.bind(this);        
        this.removeChild = this.removeChild.bind(this);
        this.handleAddRoom = this.handleAddRoom.bind(this);
        this.handleRemoveRoom = this.handleRemoveRoom.bind(this);

        if (appstate.isNonRoom) {
            this.maxAdults = NCB.Settings.HotelProperties.MaxOccupancyPerNonRoom;
            this.maxChildren = NCB.Settings.HotelProperties.MaxOccupancyPerNonRoom - 1;
        } else {
            this.maxAdults = NCB.Settings.HotelProperties.MaxAdultsPerRoom;
            this.maxChildren = NCB.Settings.HotelProperties.MaxChildrenPerRoom;
        }

        let showExpandedOptions = false;
        let useSimpleGuestSelector = (props.forceSimpleGuestSelector) ? true : NCB.Settings.UseSimpleGuestSelector;

        if (NCB.Settings.AlwaysShowExpandedGuestSelector === true || !NCB.Settings.UseSimpleGuestSelector || !useSimpleGuestSelector) {
            showExpandedOptions = true;
        } else {
            if (props.guestCount != null) {
                if (props.guestCount.length > 1) {
                    showExpandedOptions = true;
                } else {
                    let numAdults = NCB.Utils.getNumAdults(props.guestCount[0].Guests);
                    let numChildren = NCB.Utils.getNumChildren(props.guestCount[0].Guests);
    
                    if (numAdults > 2)
                        showExpandedOptions = true;
    
                    if (numChildren > 1 || (numChildren > 0 && NCB.Settings.UseChildAges === true))
                        showExpandedOptions = true;
                }
            }
        }
            
        this.state = {
            guestCount: props.guestCount,
            showMaxOccupancyMessage: false,
            showMaxRoomMessage: false,
            showExpandedOptions: showExpandedOptions,
            useSimpleGuestSelector: useSimpleGuestSelector,
            isGuestControlToggled: props.isGuestControlToggled === true
        };
    }

    componentDidUpdate(prevProps:IGuestSelectorProps, prevState: IGuestSelectorState) {
        if (this.state.isGuestControlToggled !== prevState.isGuestControlToggled) {
            if (this.state.isGuestControlToggled)
                document.body.classList.add("ncb-guestcontrol-is-toggled");
            else
                document.body.classList.remove("ncb-guestcontrol-is-toggled");
        }
    }

    componentWillReceiveProps(nextProps: IGuestSelectorProps) {
        this.setState({
            guestCount: nextProps.guestCount
        });

        if (nextProps.forceHide) {
            this.setState({
                isGuestControlToggled: false
            });
        }

        this.forceUpdate();
    }

    getMaxOccupancy = (): number => {
        return appstate.isNonRoom ? NCB.Settings.HotelProperties.MaxOccupancyPerNonRoom : NCB.Settings.HotelProperties.MaxOccupancy;
    }

    addAdult(e: any) {
        this.handleChange(1, parseInt(e.currentTarget.getAttribute("data-room-index")));
    }
    removeAdult(e: any) {
        this.handleChange(-1, parseInt(e.currentTarget.getAttribute("data-room-index")));
    }
    addChild(e: any) {
        let roomIndex = parseInt(e.currentTarget.getAttribute("data-room-index"));
        let guestCount = this.state.guestCount;

        let adults = NCB.Utils.getNumAdults(guestCount[roomIndex].Guests);

        let numChildren = 0;
        guestCount[roomIndex].Guests.filter(x => x.GuestType === CC.Library.Models.Shared.GuestType.Child).forEach(x => {
            numChildren += x.Count;
        });

        if (adults + numChildren + 1 > this.getMaxOccupancy()) {
            this.setState({
                showMaxOccupancyMessage: true
            });

            return;

        } else if (this.state.showMaxOccupancyMessage) {
            this.setState({
                showMaxOccupancyMessage: false
            });            
        }

        guestCount[roomIndex].Guests.push({
            GuestType: CC.Library.Models.Shared.GuestType.Child,
            Count: 1,
            Age: NCB.Settings.ChildMinAge
        });

        this.props.changeCallback(guestCount);
    }
    removeChild(e: any) {
        let roomIndex = parseInt(e.currentTarget.getAttribute("data-room-index"));

        let guestCount = this.state.guestCount;

        let removeIndex = -1;

        for (let i=0; guestCount[roomIndex].Guests.length > i; i++) {
            if (guestCount[roomIndex].Guests[i].GuestType === CC.Library.Models.Shared.GuestType.Child)
                removeIndex = i;
        }

        if (removeIndex  > -1)
            guestCount[roomIndex].Guests.splice(removeIndex, 1);

        this.props.changeCallback(guestCount);
    }

    handleChange(adultChange: number, roomIndex: number) {

        let guestCount = this.state.guestCount;

        let adults = NCB.Utils.getNumAdults(guestCount[roomIndex].Guests) + adultChange;
        let children = NCB.Utils.getNumChildren(guestCount[roomIndex].Guests);

        if (adults < 1)
            adults = 1;

        if (adults + children > this.getMaxOccupancy()) {
            this.setState({
                showMaxOccupancyMessage: true
            });

            return;

        } else if (this.state.showMaxOccupancyMessage) {
            this.setState({
                showMaxOccupancyMessage: false
            });            
        }

        if (adults > this.maxAdults)
            adults = this.maxAdults;

    
        let adultGuests = guestCount[roomIndex].Guests.filter(x => x.GuestType === CC.Library.Models.Shared.GuestType.Adult)[0];
        adultGuests.Count = adults;

        this.props.changeCallback(guestCount);
    }

    handleAddRoom(e: any) {

        e.stopPropagation();

        this.setState({
            showMaxOccupancyMessage: false
        });  

        let guestCount = this.state.guestCount;

        let newGuestCount: CC.Library.Models.Shared.NcbGuestCount = {
            GuestType: CC.Library.Models.Shared.GuestType.Adult,
            Count: NCB.Settings.HotelProperties.DefaultNumberOfAdults,
            Age: null
        }

        guestCount.push({
            Guests: [newGuestCount]}
        );

        this.props.changeCallback(guestCount);

        appstate.addRoom([newGuestCount]);
    }

    handleRemoveRoom(e: any) {
        e.stopPropagation();
        
        let index = parseInt(e.currentTarget.getAttribute("data-room-index"));

        console.log("Removing room with index", index);

        if (typeof index === "number") {
            appstate.removeRoom(index);
        } else {
            NCB.Log.customError("Could not remove room from guestSelector", {index: index, guestCount: this.state.guestCount});
        }

        this.setState({
            showMaxRoomMessage: false
        });
    }

    setChildAge = (newAge: number, attributes: number[]) => {

        let roomIndex = attributes[0];
        let childIndex = attributes[1];

        let g = this.state.guestCount;

        for (let i=0; g.length > i; i++) {
            for (let j=0; g[i].Guests.length > j; j++) {
                if (i === roomIndex && j === childIndex) {
                    g[i].Guests[j].Age = newAge;
                    this.props.changeCallback(g);
                    return;
                }
            }
        }

        console.error("Could not change age", newAge, childIndex, roomIndex );
    }

    generateGuestString = (): JSX.Element => {

        let numAdults = 0;
        let numChildren = 0;
        let numRooms = this.props.guestCount.length;

        this.props.guestCount.forEach(x => {
            numAdults += NCB.Utils.getNumAdults(x.Guests);
            numChildren += NCB.Utils.getNumChildren(x.Guests);
        });

        let numChildrenString: string = null;
        if (numChildren > 0) {
            numChildrenString = " + " + numChildren + " " + NCB.I18n.P("CHILD", numChildren);
        }

        return <div className="ncb-person-selector-guests-summary" onClick={() => { this.setState({isGuestControlToggled: !this.state.isGuestControlToggled}) }}>
            {numAdults} {NCB.I18n.P("ADULT", numAdults)}{numChildrenString} / {numRooms} {NCB.I18n.P("ROOM", numAdults)}
        </div>;
    }

    render() {

        let guestControls: JSX.Element;
        if (this.state.isGuestControlToggled || !this.state.useSimpleGuestSelector) {
            guestControls = (this.state.showExpandedOptions) ? this.renderGuestControls() : this.renderSimpleControls();
        }

        return <div className="ncb-person-selector-guests" data-use-simple-guest-selector={this.state.useSimpleGuestSelector} data-is-guest-control-toggled={this.state.isGuestControlToggled} data-is-expanded-options-toggled={this.state.showExpandedOptions}>
            {(this.state.useSimpleGuestSelector) ? this.generateGuestString() : null}

            {guestControls}
        </div>;
    }

    setNumGuests = (numAdults: number, numChildren: number) => {
        let guestCount = this.state.guestCount;
        guestCount[0].Guests = [
            {
                Age: null,
                Count: numAdults,
                GuestType: CC.Library.Models.Shared.GuestType.Adult
            }
        ];

        if (numChildren > 0) {
            for (let i=0; numChildren > i; i++) {
                guestCount[0].Guests.push({
                    Age: NCB.Settings.ChildMinAge,
                    Count: 1,
                    GuestType: CC.Library.Models.Shared.GuestType.Child                   
                });
            }
        }

        this.props.changeCallback(guestCount);

        // Proceed to select the child ages?
        if (NCB.Settings.UseChildAges === true && numChildren > 0) {
            this.setState({
                showExpandedOptions: true
            });
        } else {
            this.setState({
                isGuestControlToggled: false
            });
        }
    }

    renderSimpleControls = (): JSX.Element => {

        let directOptions: JSX.Element[] = [];

        directOptions.push(<div className="ncb-person-selector-guests-control-simple-link" onClick={() => this.setNumGuests(1, 0)}>1 {NCB.I18n.T.ADULT} / 1 {NCB.I18n.T.ROOM}</div>);
        directOptions.push(<div className="ncb-person-selector-guests-control-simple-link" onClick={() => this.setNumGuests(2, 0)}>2 {NCB.I18n.T.ADULT_PLURAL} / 1 {NCB.I18n.T.ROOM}</div>);
        
        if (NCB.Settings.HotelProperties.DefaultNumberOfAdults === 2)
            directOptions = directOptions.reverse();

        // Children?
        if (NCB.Settings.HotelProperties.MaxChildrenPerRoom > 0) {
            directOptions.push(<div className="ncb-person-selector-guests-control-simple-link" onClick={() => this.setNumGuests(1, 1)}>1 {NCB.I18n.T.ADULT} + 1 {NCB.I18n.T.CHILD} / 1 {NCB.I18n.T.ROOM}</div>);

            if (NCB.Settings.HotelProperties.MaxOccupancy > 2)
            directOptions.push(<div className="ncb-person-selector-guests-control-simple-link" onClick={() => this.setNumGuests(2, 1)}>2 {NCB.I18n.T.ADULT_PLURAL} + 1 {NCB.I18n.T.CHILD} / 1 {NCB.I18n.T.ROOM}</div>);
        }

        return <div className="ncb-person-selector-guests-control ncb-person-selector-guests-control-simple">

            {directOptions}

            <div className="ncb-person-selector-guests-control-more-options" onClick={() => this.setState({ showExpandedOptions: true })}>
                <span>{NCB.I18n.T.GUESTSELECTOR_MORE_OPTIONS}</span>
            </div>

        </div>
    }

    renderGuestControls = (): JSX.Element => {

        let index = -1;

        let maxOccupancyMessage: JSX.Element;
        if (this.state.showMaxOccupancyMessage) {
            if (appstate.isNonRoom) {
                maxOccupancyMessage = <div className="ncb-person-selector-max-occupancy-message" onClick={() => {this.setState({showMaxOccupancyMessage: false})}}>{NCB.I18n.T.NONROOM_MAX_OCCUPANCY_MESSAGE}</div>;
            } else {
                if (this.props.limitGuestSelection) {
                    maxOccupancyMessage = <div className="ncb-person-selector-max-occupancy-message">{NCB.I18n.T.ADD_ANOTHER_ROOM_IF_YOU_WANT_TO} <a href={NCB.Settings.BookingStartURL}>{NCB.I18n.T.ADD_MORE}</a> {NCB.I18n.T.THAN} {this.getMaxOccupancy()} {NCB.I18n.T.GUESTS}</div>;
                } else {
                    maxOccupancyMessage = <div className="ncb-person-selector-max-occupancy-message" onClick={this.handleAddRoom}>{NCB.I18n.T.ADD_ANOTHER_ROOM_IF_YOU_WANT_TO} {NCB.I18n.T.ADD_MORE} {NCB.I18n.T.THAN} {this.getMaxOccupancy()} {NCB.I18n.T.GUESTS}</div>;
                }
            }
        }

        let guestList = this.props.guestCount.map((x) => {

            index++;

            let adults = NCB.Utils.getNumAdults(x.Guests);
            let children = NCB.Utils.getNumChildren(x.Guests);

            let adultLabel = NCB.I18n.P("ADULT", adults);
            let childrenLabel = NCB.I18n.P("CHILD", children);

            let deleteRoomButton: JSX.Element = (this.props.guestCount.length > 1) ? <span className="ncb-person-selector-delete-room" onClick={this.handleRemoveRoom} data-room-index={index}><span>{NCB.I18n.T.COMMON_REMOVE}</span></span> : null;
            
            let childAgesSelector: JSX.Element = null;
            if (children > 0 && NCB.Settings.UseChildAges === true) {
                let guestIndex = -1;
                let childIndex = 0;
                childAgesSelector = <div key={"ncb-person-selector-child-ages-" + index} className="ncb-person-selector-child-ages">
                    {x.Guests.map(c => {
                        guestIndex++;
                        if (c.GuestType === CC.Library.Models.Shared.GuestType.Adult)
                            return null;
                        else
                            childIndex++;

                        return <div className="ncb-person-selector-child-age"><span>{NCB.I18n.T.CHILD} {childIndex}</span> 
                            <NumericInput type={NumericInputType.Dropdown} suffix={(NCB.I18n.T.YEAR_SHORT.toLowerCase())} onChange={this.setChildAge} attributes={[index,guestIndex]} min={NCB.Settings.ChildMinAge} max={NCB.Settings.ChildMaxAge} value={c.Age} key={"ncb-person-selector-child-age-" + index + "-" + childIndex} />
                        </div>
                    })}
                </div>
            }

            return <div className="ncb-person-selector" data-room-index={index}>
                
                <div className="ncb-person-selector-room-label">
                    {NCB.I18n.T.ROOM} {(index +1)} {deleteRoomButton}
                </div>

                <span className="ncb-person-selector-segment ncb-person-selector-segment-adults" data-num-selected={adults}>
                    <span className="ncb-person-selector-segment-content">{adults} {adultLabel}</span>
                    <span className="ncb-decrement-control" onClick={this.removeAdult} data-room-index={index}>-</span>
                    <span className="ncb-increment-control" onClick={this.addAdult} data-room-index={index}>+</span>
                </span>
                <span className="ncb-person-selector-segment ncb-person-selector-segment-children" data-num-selected={children}>
                    <span className="ncb-person-selector-segment-content">{children} {childrenLabel}</span>
                    <span className="ncb-decrement-control" onClick={this.removeChild} data-room-index={index}>-</span>
                    <span className="ncb-increment-control" onClick={this.addChild} data-room-index={index}>+</span>
                </span>

                {childAgesSelector}
            </div>;
        });

        let addRoom: JSX.Element;
        if (appstate.isNonRoom || (appstate.modifyConfirmationNumber != null && appstate.modifyConfirmationNumber.length > 0)) {
            addRoom = null;
        } else  {
            if (guestList.length < NCB.Settings.HotelProperties.MaxReservationsPerItinerary) {
                addRoom = <div id="ncb-person-selector-add-room" className="ncb-person-selector-add-room" onClick={this.handleAddRoom}>{NCB.I18n.T.CART_ADD_ROOM}</div>;
            } else if (this.state.showMaxRoomMessage) {
                addRoom = <div id="ncb-person-selector-additional-rooms" className="ncb-person-selector-additional-rooms">
                    
                    <div className="ncb-person-selector-additional-rooms-message">
                        {NCB.I18n.T.ADD_MORE_ROOMS_THAN_ALLOWED.replace('%MAX_ROOMS%', ("" + NCB.Settings.HotelProperties.MaxReservationsPerItinerary))}
                    </div>
                    
                    <div className="ncb-person-selector-additional-rooms-email">
                        <a href={"mailto:" + NCB.Settings.HotelEmailAddress}>{NCB.Settings.HotelEmailAddress}</a>
                    </div>
                    <div className="ncb-person-selector-additional-rooms-phone">
                        <a href={"tel:" + NCB.Settings.HotelPhoneNumber}>{NCB.Settings.HotelPhoneNumber}</a>
                    </div>
                    
                </div>;
            } else {
                addRoom = <div id="ncb-person-selector-add-room" className="ncb-person-selector-add-room" onClick={() => { this.setState({showMaxRoomMessage: true}) }}>{NCB.I18n.T.CART_ADD_ROOM}</div>;
            }
        }
            

        return <div className="ncb-person-selector-guests-control" data-num-rooms={this.props.guestCount.length} data-is-multiple-rooms={this.props.guestCount.length > 1}>
            {guestList}
        
            {addRoom}

            {maxOccupancyMessage}

            <div className="ncb-person-selector-guests-control-submit-wrapper">
                <button disabled={!this.props.isSubmitEnbled} className="ncb-button ncb-person-selector-guests-control-submit" onClick={(e: any) => this.props.onSubmit()}>
                    <span>
                        { NCB.I18n.T.VIEW_ROOM_AND_PRICES }
                    </span>
                </button>
            </div>

        </div>;
    }
}




// WEBPACK FOOTER //
// ./src/components/datepicker/guestSelector.tsx